import PaymentService from '@/services/payment.service.js'

const state = {
  payments: [],
  loading: false,
  currentPayment: null
}

const getters = {
  payments: state => state.payments,
  loading: state => state.loading,
  currentPayment: state => state.currentPayment
}

const actions = {
  async fetchPayments({ commit, dispatch }, params = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await PaymentService.getPayments(params)
      const data = response.payload?.responseData || response.payload || response
      commit('SET_PAYMENTS', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load payments',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchPaymentById({ commit, dispatch }, id) {
    try {
      commit('SET_LOADING', true)
      const response = await PaymentService.getPaymentById(id)
      const data = response.payload?.responseData || response.payload || response
      commit('SET_CURRENT_PAYMENT', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load payment',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createPayment({ commit, dispatch }, payload) {
    try {
      commit('SET_LOADING', true)
      const response = await PaymentService.createPayment(payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Payment recorded successfully',
        { root: true }
      )
      await dispatch('fetchPayments')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to record payment',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updatePayment({ commit, dispatch }, { id, payload }) {
    try {
      commit('SET_LOADING', true)
      const response = await PaymentService.updatePayment(id, payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Payment updated successfully',
        { root: true }
      )
      await dispatch('fetchPayments')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to update payment',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deletePayment({ commit, dispatch }, id) {
    try {
      commit('SET_LOADING', true)
      const response = await PaymentService.deletePayment(id)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Payment deleted successfully',
        { root: true }
      )
      await dispatch('fetchPayments')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to delete payment',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  clearCurrentPayment({ commit }) {
    commit('SET_CURRENT_PAYMENT', null)
  }
}

const mutations = {
  SET_PAYMENTS(state, payments) {
    state.payments = payments.payments
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_CURRENT_PAYMENT(state, payment) {
    state.currentPayment = payment
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
